export default [
    'ab',
    'aus',
    'außer',
    'bei',
    'mit',
    'nach',
    'seit',
    'von',
    'zu',
    'gegenüber'
];